<template>
    <!-- 底部操作栏 -->
    <div class="bottom-actionbar container" :class="{ 'style2': isVerticalStyle }">
        <div class="zan " @click="clickZan">
            <img v-if="isVerticalStyle" src="@/assets/images/live/playing/icon_zan_white.png" class="icon">
            <img v-else src="@/assets/images/live/playing/icon_zan.png" class="icon">

        </div>
        <div class="input-box" @click="clickQuestion">
            <!-- <van-field disabled class="input" v-model="text" placeholder="说点什么吧..." /> -->
            <div class="input input-text ">说点什么吧...</div>
            <van-checkbox class="checkbox" icon-size="0.32rem" :checked-color="currentBrandColor.mainColor">提问
            </van-checkbox>
        </div>

        <div class="car button" v-if="showCar" @click="clickCar">
            <img src="@/assets/images/live/playing/icon_car.png" class="icon">
        </div>

        <div class="button" v-if="showCustomer" @click="clickCustomer">
            <img src="@/assets/images/live/playing/icon_wx.png" class="icon">
        </div>

        <div class="button" v-if="showGift" @click="clickGift">
            <img src="@/assets/images/live/playing/icon_gift.png" class="icon">
        </div>
    </div>
</template>
<script>
export default {
    props: {
        showCar: Boolean,
        showCustomer: Boolean,
        showGift: Boolean,
        theme: { //样式控制  1横屏 2竖屏
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            checked: false,
            text: '',
            currentBrandColor: {}
        }
    },
    computed: {
        // 是否竖屏样式
        isVerticalStyle() {
            return this.theme === 2
        }
    },
    methods: {
        clickZan() {
            this.$emit('onZan')
        },
        clickCar() {
            this.$emit('onCar')
        },
        clickQuestion() {
            this.$emit('onQuestion')
        },
        clickCustomer() {
            this.$emit('onCustomer')

        },
        clickGift() {
            this.$emit('onGift')

        },
    },
    mounted() {
        this.currentBrandColor = this.getCurrentBrandColor()
    },
}
</script>
<style lang="scss" scoped>
.bottom-actionbar {
    position: fixed;
    left: 0;
    width: 100%;
    bottom: 0;
    @include flex_center;
    background-color: #fff;
    padding-top: .32rem;
    padding-bottom: .75rem;

    .zan,
    .car {
        @include flex_center;
        width: 1rem;
        height: 1rem;
    }

    .zan {
        background: #F7F8FA;
        border-radius: 50%;

        .icon {
            width: 0.53rem;
            height: 0.53rem;
        }
    }

    .car {
        .icon {
            width: .64rem;
        }
    }

    .input-box {
        @include flex_center;
        flex: 1;
        margin: 0 .32rem;
        height: 1rem;
        background: #F7F8FA;
        border-radius: 0.53rem;
        padding: 0 .32rem;
        margin-right: 0;

        .input {
            flex: 1;
            margin-right: .2rem;

        }

        .input-text {
            font-size: 0.37rem;
            border: none;
            color: #fff;
            opacity: 0.7;

        }

        .van-cell {
            background-color: transparent;

            &::after {
                display: none;
            }

            ::v-deep {

                input {
                    font-size: 0.37rem;
                    border: none;

                    &::placeholder {
                        color: #919499;
                    }
                }
            }
        }

        .checkbox {

            /deep/ .van-checkbox__label {
                font-size: 0.32rem;
                color: #18191A;
                margin-left: .1rem;
                line-height: 1;
            }
        }


    }

    // 竖屏样式
    &.style2 {
        background-color: transparent;
        padding-left: .32rem;
        padding-right: .22rem;

        .zan {
            background-color: rgba($color: #000000, $alpha: 0.2);
        }

        .button {
            @include flex_center;
            width: 1rem;
            height: 1rem;
            background-color: rgba($color: #000000, $alpha: 0.2);
            border-radius: 50%;
            margin: 0 .11rem;

            .icon {
                width: .53rem;
                height: .53rem;
            }
        }

        .input-box {
            background-color: rgba($color: #000000, $alpha: 0.2);
            margin-right: .1rem;
        }

        .checkbox {
            ::v-deep {
                input {
                    &::placeholder {
                        color: #EBECF0;
                    }
                }
            }

            /deep/ .van-checkbox__label {
                color: #FFFFFF;
            }
        }

    }
}
</style>